import { Stack, Typography } from "@mui/material";
export default function LevelExplorer() {
    return (
        <Stack>
            <Typography>Hello, this is about Spreezy Mart</Typography>
            <Typography>yadayadayada</Typography>
        </Stack>)
}

